export default __webpack_public_path__ + "static/media/FFLogo.9f6e772f.png";